/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PacienteModelDto } from '../../models/paciente-model-dto';

export interface DoctorEncuestasControllerObtenerEncuestasDeUsuarios$Params {
}

export function doctorEncuestasControllerObtenerEncuestasDeUsuarios(http: HttpClient, rootUrl: string, params?: DoctorEncuestasControllerObtenerEncuestasDeUsuarios$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PacienteModelDto>>> {
  const rb = new RequestBuilder(rootUrl, doctorEncuestasControllerObtenerEncuestasDeUsuarios.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PacienteModelDto>>;
    })
  );
}

doctorEncuestasControllerObtenerEncuestasDeUsuarios.PATH = '/api/doctor-encuestas/obtener-encuestas-usuarios';
